@if (appError$ | async) { <app-error /> }
@if (((appIsLoading$ | async) ?? 0) > 0) { <app-loading /> }
<router-outlet />